// extracted by mini-css-extract-plugin
export default {"grid":"Platforms_grid__r2ITZ","titleSection":"Platforms_titleSection__q2T93","list":"Platforms_list__usJVz"};